// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"897":"257933df","978":"cd0da22f"}[chunkId] + ".chunk.css";
};